import { render, staticRenderFns } from "./AbkCarousel.vue?vue&type=template&id=f8993582&scoped=true&"
import script from "./AbkCarousel.vue?vue&type=script&lang=js&"
export * from "./AbkCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AbkCarousel.vue?vue&type=style&index=0&id=f8993582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8993582",
  null
  
)

export default component.exports